import { render, staticRenderFns } from "./SliderBannerSupplier.vue?vue&type=template&id=2de30e64&scoped=true&"
import script from "./SliderBannerSupplier.vue?vue&type=script&lang=js&"
export * from "./SliderBannerSupplier.vue?vue&type=script&lang=js&"
import style0 from "./SliderBannerSupplier.vue?vue&type=style&index=0&id=2de30e64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de30e64",
  null
  
)

export default component.exports